// extracted by mini-css-extract-plugin
export var carrierTab = "_3j-0";
export var carrierTabActive = "_3j-1 _3j-0";
export var carrierTabInactive = "_3j-2 _3j-0";
export var carrierTabLabel = "_3j-3";
export var carrierTabLabelActive = "_3j-4 _3j-3";
export var carrierTabLabelInactive = "_3j-5 _3j-3";
export var carrierTabPercentage = "_3j-6";
export var carrierTabPercentageActive = "_3j-7 _3j-6";
export var carrierTabPercentageInactive = "_3j-8 _3j-6";
export var carrierTabWinnable = "_3j-9";
export var carrierTabWinnableActive = "_3j-a _3j-9";
export var carrierTabWinnableInactive = "_3j-b _3j-9";
export var comparisonContainer = "_3j-d";
export var missingRateButton = "_3j-n";
export var missingRateButtonActive = "_3j-o _3j-n";
export var missingRateButtonInactive = "_3j-p _3j-n";
export var missingRateButtonLabel = "_3j-q";
export var missingRateButtonLabelActive = "_3j-r _3j-q";
export var missingRateButtonLabelInactive = "_3j-s _3j-q";
export var sidebar = "_3j-c";
export var strategyButton = "_3j-e";
export var strategyButtonActive = "_3j-f _3j-e";
export var strategyButtonDescription = "_3j-k";
export var strategyButtonDescriptionActive = "_3j-l _3j-k";
export var strategyButtonDescriptionInactive = "_3j-m _3j-k";
export var strategyButtonInactive = "_3j-g _3j-e";
export var strategyButtonLabel = "_3j-h";
export var strategyButtonLabelActive = "_3j-i _3j-h";
export var strategyButtonLabelInactive = "_3j-j _3j-h";
export var unitToggleButton = "_3j-t";
export var unitToggleButtonActive = "_3j-u _3j-t";
export var unitToggleButtonInactive = "_3j-v _3j-t";
export var unitToggleButtonLabel = "_3j-w";
export var unitToggleButtonLabelActive = "_3j-x _3j-w";
export var unitToggleButtonLabelInactive = "_3j-y _3j-w";